import { React, useState } from 'react';
import { Button } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Rejected } from '../../services/Contexture/Rejected';
import { toast } from 'react-toastify';

library.add(fal);

const RejectButton = ({ profileId, docId }) => {
  const [rejected, setRejected] = useState(false);
  const handleClick = async () => {
    try {
      const response = await Rejected.addDocument(docId, { profileId });

      if (response) {
        setRejected(true);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('refreshDocLists'));
        }
        toast.success('Marked as not relevant', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error('Failed to mark as not relevant', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <Button
      variant='text'
      onClick={() => handleClick()}
      className='reject-watchlist'
      data-testid='reject-button'
    >
      <FontAwesomeIcon
        icon={rejected ? ['fal', 'check'] : ['fal', 'thumbs-down']}
      ></FontAwesomeIcon>
    </Button>
  );
};
export default RejectButton;
